import { Text } from 'react-native'
import SplashAnimatedShell from './SplashAnimatedShell'
import { SplashStyles } from '../styles/SplashStyles'
import { clubBranding } from '../config/clubBranding'

const SplashScreen = () => {
    return (
        <SplashAnimatedShell backgroundColor={clubBranding.splashBackground}>
            {clubBranding.name ? (
                <Text style={SplashStyles.title}>{clubBranding.name}</Text>
            ) : null}
            {clubBranding.tagline ? (
                <Text style={SplashStyles.tagline}>{clubBranding.tagline}</Text>
            ) : null}
        </SplashAnimatedShell>
    )
}

export default SplashScreen
